import { css } from 'lit-element';

export const theme = css`
	hr {
		border: 0;
		height: 1px;
		background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(237, 116, 34, 0.75), rgba(0, 0, 0, 0));
	}
	a {
		text-decoration: underline solid #333;
	}
	a, p, div, span, button, input, select {
		color: var(--theme-primary, black);
	}
	*:focus {
		outline: thin solid rgba(237, 116, 34, 0.75);
	}
	button, .button {
		cursor: pointer;
		user-select: none;
		font-family: var(--theme-font-family, Arial);
		border: var(--theme-border, black);
		border-radius: 0.25em;
		padding: var(--theme-button-padding, 0.25em);
		background: var(--theme-background, white);
		transition: all 0.2s;
		text-decoration: none;
		font-size: .85em;
		padding: 0.5em;
	}
	button:hover, button:focus, .button:hover, .button:focus {
		background: var(--theme-background-hover, green);
	}
	fieldset {
		border: var(--theme-border, red);
		background: var(--theme-background, red);
		border-radius: 0.25em;
	}
	legend {
		border: var(--theme-border, red);
		background: var(--theme-background, red);
		border-radius: 0.25em;
	}
	input[type="text"], input[type="password"], input[type="date"], input[type="tel"] {
		border: var(--theme-border, 1px solid black);
		border-radius: 0.25em;
		background: var(--theme-background, red);
		transition: all 0.2s;
		padding: 0.25em;
	}
	input[type="text"]:hover, 
	input[type="password"]:hover, 
	input[type="text"]:focus, 
	input[type="password"]:focus,
	input[type="date"]:hover,
	input[type="date"]:focus,
	input[type="tel"]:hover,
	input[type="tel"]:focus {
		background: var(--theme-background-hover, red);
	}
	.checkbox {
		position: relative;
	}
	.checkbox input[type="checkbox"] {
		opacity: 0;
	}
	.checkbox > label {
		position: absolute;
		top: 0;
		left: 0;
	}
	/*Outer box of the fake checkbox*/
	.checkbox > label::before{
		position: absolute;
		content: "";
		display: inline-block;

		height: 1em;
		width: 1em;
		
		left: 0px;
		top: 0px;
		background-color: #ffffff; //#0075ff;
		border: 1px solid black;
		border-radius: 0.125em;
	}
	/*Checkmark of the fake checkbox*/
	.checkbox > label::after {
		position: absolute;
		content: "";
		display: inline-block;

		height: 4px;
		width: 8px;
		border-left: 2px solid;
		border-bottom: 2px solid;
		
		transform: rotate(-45deg);
		color: white;
		
		left: 4px;
		top: 4px;
	}
	.checkbox input[type="checkbox"]:checked + label::before {
		background-color: rgba(237, 116, 34, 1);
		border: 1px solid rgba(237, 116, 34, 1);
	}
	/*Hide the checkmark by default*/
	.checkbox input[type="checkbox"] + label::after {
		content: none;
	}
	/*Unhide on the checked state*/
	.checkbox input[type="checkbox"]:checked + label::after {
		content: "";
	}
	/*Adding focus styles on the outer-box of the fake checkbox*/
	.checkbox input[type="checkbox"]:focus + label::before {
		// outline: rgb(59, 153, 252) auto 1px;
	}
	select {
		font-family: var(--theme-font-family, Arial);
		border: var(--theme-border, black);
		padding: var(--theme-select-padding, 0.25em);
		background: var(--theme-background, red);
		transition: all 0.2s;
	}
	select:hover, select:focus {
		background: var(--theme-background-hover, green);
	}
	thead tr {
		background: var(--theme-thead-background, #ccc);
	}
	thead tr th {
		font-weight: normal;
	}
	.data-table tbody tr {
		background-color: #fff;
	}
	.data-table tbody tr.even {
		background-color: #eee;
	}
	.data-table tbody tr:hover {
		background-color: #ccc;
	}
	.icon {
		height: 1em;
		position: relative;
		top: 0.15em;
	}
	.info {
		border: var(--theme-border-info, 1px solid black);
		border-radius: 0.25em;
		background-color: var(--theme-background-hover, white);
		padding: 0.25em;
		margin: 0.25em;
	}
	.no-display {
		display: none !important;
	}
	@media print {
		.no-print {
			display: none !important;
		}
	}
`;